import styled from '@emotion/styled';
import { Box } from '@mui/material';

import { COLORS, SPACE } from '../../constants';

const ScorecardWrapper = styled.div`
  background-color: ${COLORS.WHITE};
  box-shadow: 0 1px 5px 1px ${COLORS.GREY_FOUR};
  border-radius: 0;
  padding: ${SPACE.X3} 0;
  width: 100%;
`;

const StarRatingWrapper = styled.div`
  margin-bottom: ${SPACE.X2};
`;

const SafetyFeatureWrapper = styled.div`
  border-top: 2px solid ${COLORS.GREY_THREE};
  padding-top: ${SPACE.X1};
`;

const Divider = styled(Box)`
  border-top: 2px solid ${COLORS.GREY_THREE};
  padding-top: ${SPACE.X1};
`;

export { Divider, StarRatingWrapper, SafetyFeatureWrapper, ScorecardWrapper };
